/* eslint-disable react/jsx-fragments */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { Loader, Modal } from 'sa-ui';

import { Row, Col } from 'react-bootstrap';
import messages from '../onlineSimulatedMessages';

import QuestionCard from './QuestionCard';
import ComposingCard from './ComposingCard';

import {
  answerEvaluationOnline,
  answerQuestion,
  finishScheduledAssessment,
  viewEvaluationOnline,
  getEvaluationEssayDetails,
  saveEvaluationEssayText,
} from '../onlineSimulatedActions';

import './SimulatedEvaluationContainer.scss';

const SimulatedEvaluationContainer = (props) => {
  const {
    evaluation,
    isLoading,
    user,
    intl,
    essayDetails,
    errorEssaySaveMessage,
    essaySaving,
    essaySaved,
  } = props;
  const { idEvaluation } = props.match.params;
  const { languageSelected, courseName, idEvaluationOnline, evalutationStatus, timeEnd, dateEnd } =
    props.location.state;
  const [studentInfo, setStudentInfo] = useState({});
  const [initials, setInitials] = useState('');
  const [alternativeAnswered, setAlternativeAnswered] = useState(null);
  const [idAlternative, setIdAlternative] = useState(null);
  const [[hrs, mins, secs], setTimer] = useState([0, 0, 60]);
  const [modalFinished, setModalFinished] = useState(false);
  const [changeAlternative, setChangeAlternative] = useState(false);
  const [lastAlternative, setLastAlternative] = useState(null);
  const [hasComposing, setHasComposing] = useState(false);
  const [composingAnswered, setComposingAnswered] = useState(false);
  const [composingActive, setComposingActive] = useState(false);
  const [composingTextSaved, setComposingTextSaved] = useState('');
  const [showModalComposing, setShowModalComposing] = useState(false);
  const [showOneTime, setShowOneTime] = useState(true);
  const [essayPreviewText, setEssayPreviewText] = useState('');
  const [lastNavPosition, setLastNavPosition] = useState(1);
  const [essayLengthError, setEssayLengthError] = useState('');

  async function handleFinishAttempt(status) {
    if (user.idType > 3) {
      if (!status) {
        await props.answerQuestion({
          idAttempt: evaluation.idAttempt,
          idQuestion: evaluation.question ? evaluation.question.idQuestion : null,
          idAlternative: lastAlternative,
          answerText: null,
        });
      }

      if (essayLengthError === '' && hasComposing && composingTextSaved.length > 0) {
        handleComposingSave(composingTextSaved, true);
      }
      localStorage.removeItem('composingActive');
      await props.finishScheduledAssessment({
        idAttempt: evaluation.idAttempt,
      });
      props.history.push('/online-simulated');
    } else {
      props.history.push(`/simulated/${idEvaluation}`);
    }
  }

  useEffect(() => {
    (async () => {
      document.body.classList.remove('modal-open');
      if (user.idType > 3) {
        props.answerEvaluationOnline({
          idESEvaluation: idEvaluation,
          idEvaluationOnline,
          languageOption: languageSelected,
          questionNumber: 1,
        });
        await props.getEvaluationEssayDetails({ idESEvaluation: idEvaluation, idEvaluationOnline });
        setStudentInfo({
          schoolName: user.schoolName ? `${user.schoolName} - ` : '',
          courseName,
          studentName: `${user.firstName} ${user.lastName}`,
        });
      } else {
        props.viewEvaluationOnline({
          idESEvaluation: idEvaluation,
          questionNumber: 1,
        });
      }
    })();

    if (localStorage.getItem('composingActive')) {
      setComposingActive(true);
      setShowOneTime(false);
    }
  }, []);

  useEffect(() => {
    if (evaluation.question) setLastAlternative(evaluation.question.answer);

    if (user.idType <= 3 && Object.keys(evaluation).length > 0) {
      if (evaluation.duration === '0:0:0' || evaluation.duration === '00:00:00') {
        handleFinishAttempt('finishOnStart');
      }
    }
  }, [evaluation]);

  useEffect(() => {
    if (studentInfo.studentName) {
      let initialsAux = studentInfo.studentName.match(/\b\w/g) || [];
      initialsAux = ((initialsAux.shift() || '') + (initialsAux.pop() || '')).toUpperCase();

      setInitials(initialsAux);
    }
  }, [studentInfo]);

  useEffect(() => {
    if (props.finishAssessment) {
      props.history.push('/online-simulated');
    }
  }, [props.finishAssessment]);

  useEffect(() => {
    if (evaluation.idAttempt) {
      if (evalutationStatus === 'available' && timeEnd) {
        const timeEndSplit = timeEnd.split(':');
        const timeEndHours = parseInt(timeEndSplit[0], 10);
        const timeEndMinutes = parseInt(timeEndSplit[1], 10);
        const currentTime = new Date();
        const currentHours = currentTime.getHours();
        const currentMinutes = currentTime.getMinutes();

        const currentDate = new Date();
        const dd = String(currentDate.getDate()).padStart(2, '0');
        const mm = String(currentDate.getMonth() + 1).padStart(2, '0'); // January is 0!
        const yyyy = currentDate.getFullYear();
        const currentDateFormatted = `${yyyy}-${mm}-${dd}`;

        if (dateEnd <= currentDateFormatted) {
          if (
            timeEndHours < currentHours ||
            (timeEndHours === currentHours && timeEndMinutes === currentMinutes) ||
            (timeEndHours === currentHours && timeEndMinutes < currentMinutes)
          ) {
            handleFinishAttempt('finishOnStart');
          }
        }
      }
    }
  }, [evaluation.idAttempt]);

  useEffect(() => {
    if (essayDetails && essayDetails.studentText) {
      setComposingTextSaved(essayDetails.studentText);
      setComposingAnswered(true);
    }
  }, [essayDetails]);

  useEffect(() => {
    if (Object.keys(evaluation).length > 0) {
      const duration = evaluation.duration ? evaluation.duration.split(':') : ['0', '0', '0'];
      setTimer([parseInt(duration[0]), parseInt(duration[1]), parseInt(duration[2])]);

      if (evaluation.applicationMethod === '4' && essayDetails) {
        setHasComposing(true);
      }
    }
  }, [evaluation]);

  useEffect(() => {
    const timerId = setInterval(() => tick(hrs), 1000);
    return () => clearInterval(timerId);
  });

  useEffect(() => {
    if (composingActive) {
      localStorage.setItem('composingActive', true);
    } else {
      localStorage.removeItem('composingActive');
    }
  }, [composingActive]);

  function handleAlternativeAnswered(answer, position, alternative) {
    setAlternativeAnswered(answer ? position : null);
    setIdAlternative(alternative);
    setChangeAlternative(true);
    setLastAlternative(alternative);
  }

  async function handleQuestionNavigation(navPosition, questionPosition) {
    setLastNavPosition(navPosition);
    if (user.idType > 3) {
      setComposingActive(false);
      if (changeAlternative) {
        await props.answerQuestion({
          idAttempt: evaluation.idAttempt,
          idQuestion: evaluation.question ? evaluation.question.idQuestion : null,
          idAlternative,
          answerText: null,
        });
        setChangeAlternative(false);
      }
      if (navPosition !== questionPosition) {
        setTimeout(() => {
          props.answerEvaluationOnline({
            idESEvaluation: idEvaluation,
            idEvaluationOnline,
            languageOption: languageSelected,
            questionNumber: navPosition,
          });
        }, 500);
        setAlternativeAnswered(null);
        setLastAlternative(evaluation.question.answer);
        window.scrollTo(0, 0);
      }

      if (
        composingTextSaved !== essayPreviewText &&
        composingTextSaved.length > 0 &&
        essayPreviewText.length > 0
      ) {
        const essayText =
          composingTextSaved !== essayPreviewText ? essayPreviewText : composingTextSaved;
        handleComposingSave(essayText);
      }
    } else {
      props.viewEvaluationOnline({
        idESEvaluation: idEvaluation,
        questionNumber: navPosition,
      });
      window.scrollTo(0, 0);
    }
  }

  async function handleBtnNavigation(position, status, alternative) {
    if (user.idType > 3) {
      setComposingActive(false);
      if (changeAlternative) {
        await props.answerQuestion({
          idAttempt: evaluation.idAttempt,
          idQuestion: evaluation.question ? evaluation.question.idQuestion : null,
          idAlternative: alternative,
          answerText: null,
        });
        setChangeAlternative(false);
        setLastAlternative(null);

        if (status === 'essay') {
          if (showOneTime) {
            setShowModalComposing(true);
          } else {
            setComposingActive(true);
          }
        }
      }
      if (status === 'next' || status === 'prev' || status === 'essay') {
        setTimeout(() => {
          props.answerEvaluationOnline({
            idESEvaluation: idEvaluation,
            idEvaluationOnline,
            languageOption: languageSelected,
            questionNumber: position,
          });
        }, 500);

        setAlternativeAnswered(null);
        setLastAlternative(alternative);
        window.scrollTo(0, 0);
      }
      if (status === 'finish') {
        setModalFinished(true);
        setLastAlternative(alternative);
      }

      if (status === 'essay') {
        if (showOneTime) {
          setShowModalComposing(true);
        } else {
          setComposingActive(true);
        }
      }
    } else {
      props.viewEvaluationOnline({
        idESEvaluation: idEvaluation,
        questionNumber: position,
      });
    }
  }

  function handleShowModalComposing() {
    setShowModalComposing(false);
    setComposingActive(true);
    setShowOneTime(false);
  }

  async function handleComposingNavigation() {
    await props.answerQuestion({
      idAttempt: evaluation.idAttempt,
      idQuestion: evaluation.question ? evaluation.question.idQuestion : null,
      idAlternative: lastAlternative,
      answerText: null,
    });

    setTimeout(() => {
      props.answerEvaluationOnline({
        idESEvaluation: idEvaluation,
        idEvaluationOnline,
        languageOption: languageSelected,
        questionNumber: lastNavPosition,
      });
    }, 500);

    setAlternativeAnswered(null);
    setLastAlternative(lastAlternative);
    window.scrollTo(0, 0);

    if (showOneTime) {
      setShowModalComposing(true);
    } else {
      setComposingActive(true);
    }
  }

  function tick() {
    if (hrs === 0 && mins === 0 && secs === 0) handleFinishAttempt();
    else if (mins === 0 && secs === 0) {
      setTimer([hrs - 1, 59, 59]);
    } else if (secs === 0) {
      setTimer([hrs, mins - 1, 59]);
    } else {
      setTimer([hrs, mins, secs - 1]);
    }
  }

  function handleComposingSave(text, finish = false) {
    setComposingTextSaved(text);
    props.saveEvaluationEssayText({
      idESEvaluation: idEvaluation,
      idEvaluationOnline,
      text: text,
      finish: finish ? 1 : 0,
    });
  }

  function handleEssayPreviewText(e) {
    setEssayPreviewText(e);
  }

  return (
    <div className="evaluationContainer">
      <Loader show={isLoading} />
      {Object.keys(evaluation).length > 0 && (
        <div>
          <h6 className="subtitle">
            <span>{evaluation && evaluation.disciplines.map((el) => `${el} | `)}</span>
            <span>ID: {evaluation && evaluation.evaluationCode}</span>
          </h6>
          {user.idType <= 3 && (
            <button
              type="button"
              className="navQuestionBtn my-3"
              onClick={() => props.history.push(`/simulated/${idEvaluation}`)}
            >
              {intl.formatMessage(messages.back)}
            </button>
          )}

          <hr />
          {studentInfo.studentName && user.idType > 3 && (
            <Fragment>
              <Row className="align-items-center my-4">
                <Col xs={12}>
                  <div className="d-flex align-items-center">
                    <span className="initials inline mr-3" style={{ backgroundColor: '#D4A1DD' }}>
                      {initials}
                    </span>
                    <div style={{ lineHeight: '1rem' }}>
                      <strong>{studentInfo.studentName}</strong>
                      <br />
                      <span className="small">
                        {studentInfo.schoolName}
                        {studentInfo.courseName}
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>
              <hr />
            </Fragment>
          )}
          <Row className="align-items-start my-4">
            <Col
              xs={12}
              md={8}
              className="pe-3 mb-4 columnLeft"
              style={{ borderRight: '1px solid #eee' }}
            >
              {!composingActive ? (
                <QuestionCard
                  question={evaluation.question ? evaluation.question : []}
                  questionOptional={
                    evaluation.questionOptional ? evaluation.questionOptional : null
                  }
                  totalQuestions={evaluation.totalQuestions}
                  alternativeAnswered={(answer, alternative) =>
                    handleAlternativeAnswered(answer, evaluation.question.position, alternative)
                  }
                  handleBtnNavigation={(position, status, alternative) =>
                    handleBtnNavigation(position, status, alternative)
                  }
                  user={user}
                  hasEssay={hasComposing}
                />
              ) : (
                <ComposingCard
                  composingTextSaved={composingTextSaved}
                  essayDetails={essayDetails}
                  save={(e) => handleComposingSave(e)}
                  errorEssaySaveMessage={errorEssaySaveMessage}
                  saving={essaySaving}
                  saved={essaySaved}
                  setFinishErrorStatus={(e) => setEssayLengthError(e)}
                  modalFinished={modalFinished}
                  essayPreviewText={(e) => handleEssayPreviewText(e)}
                />
              )}
            </Col>
            <Col xs={12} md={4} className="ps-3">
              <div className="mb-2">
                <strong>{intl.formatMessage(messages.questionNavigation)}:</strong>
              </div>
              {evaluation.navigation.map((nav) => (
                <div>
                  <div className="navTitle">{nav.name}</div>
                  <div className="d-flex flex-wrap gap">
                    {nav.questions.map((question) => (
                      <button
                        type="button"
                        className={`navButton ${
                          evaluation.question.position === question.position &&
                          !composingActive &&
                          'active'
                        }`}
                        onClick={() =>
                          handleQuestionNavigation(question.position, evaluation.question.position)
                        }
                      >
                        <div className="position">{question.position}</div>
                        {(question.answered || alternativeAnswered === question.position) && (
                          <div className="answered" />
                        )}
                      </button>
                    ))}
                  </div>
                </div>
              ))}
              {hasComposing && (
                <div>
                  <div className="navTitle">{intl.formatMessage(messages.composing)}</div>
                  <div className="d-flex flex-wrap gap">
                    <button
                      type="button"
                      className={`navButton ${composingActive && 'active'}`}
                      onClick={() => handleComposingNavigation()}
                    >
                      <div className="position">
                        <svg
                          width="44.127"
                          height="44.127"
                          viewBox="0 0 44.127 44.127"
                          style={{ width: '20px', height: '20px' }}
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <rect
                                id="Retângulo_1"
                                data-name="Retângulo 1"
                                width="44.127"
                                height="44.127"
                                transform="translate(0 0)"
                                fill="none"
                              />
                            </clipPath>
                          </defs>
                          <g id="Grupo_2" data-name="Grupo 2" transform="translate(0 0)">
                            <g id="Grupo_1" data-name="Grupo 1" clip-path="url(#clip-path)">
                              <path
                                id="Caminho_1"
                                data-name="Caminho 1"
                                d="M0,43.093c.313-1.265.634-2.528.938-3.8.617-2.579,1.216-5.163,1.848-7.739a1.881,1.881,0,0,1,.473-.84Q17.49,16.462,31.742,2.228A7.186,7.186,0,1,1,41.9,12.388c-1.961,1.98-3.939,3.942-5.909,5.912Q24.749,29.543,13.5,40.774a2.371,2.371,0,0,1-1.056.587C8.722,42.272,5,43.15,1.272,44.039a2.061,2.061,0,0,0-.238.088H0V43.093m9.041-8.006c1.271-.145,2.481-.276,3.687-.433a.856.856,0,0,0,.409-.281q6.388-6.378,12.769-12.762,2.363-2.361,4.726-4.72A.8.8,0,0,1,31.85,16.8a.828.828,0,0,1-.1,1.221c-.289.3-.589.59-.883.884Q22.585,27.19,14.3,35.48c-.128.128-.3.278-.318.436-.111.76-.179,1.526-.256,2.241l21.95-21.941L27.951,8.485,6.033,30.4c.554-.064,1.208-.164,1.865-.206a1.132,1.132,0,0,0,.775-.38q8.616-8.628,17.244-17.245a3.287,3.287,0,0,1,.38-.348.781.781,0,0,1,1.024.047.767.767,0,0,1,.067,1.055,3.47,3.47,0,0,1-.351.378Q18.4,22.339,9.764,30.979a.983.983,0,0,0-.3.489c-.155,1.18-.278,2.363-.42,3.619M7.793,31.813c-1.089.119-2.1.242-3.111.333a.485.485,0,0,0-.514.439C3.8,34.219,3.4,35.848,3.013,37.478L2.239,40.73c.547-.467,1-1.213,1.684-.549.7.685-.06,1.156-.519,1.7l1.807-.426c2.1-.5,4.21-1,6.311-1.509.161-.039.4-.191.417-.316.147-1.074.25-2.154.369-3.251a4.808,4.808,0,0,0-.5,0q-1.712.186-3.42.384a.852.852,0,0,1-1.033-1.011c.034-.3.073-.6.106-.9.109-1,.216-1.989.33-3.045m33.63-21.344a5.547,5.547,0,0,0-7.761-7.76l7.761,7.76M40.23,11.722l-7.8-7.8L31.387,4.939l7.811,7.81,1.032-1.027M38,14.009,30.129,6.141l-1,1.043,7.852,7.843L38,14.009"
                              />
                            </g>
                          </g>
                        </svg>
                      </div>
                      {composingAnswered && <div className="answered" />}
                    </button>
                  </div>
                </div>
              )}
              {user.idType > 3 && (
                <button
                  type="button"
                  className="finishAttempt"
                  onClick={() => setModalFinished(true)}
                  disabled={hasComposing && showOneTime && composingAnswered ? true : false}
                >
                  {intl.formatMessage(messages.finishAttempt)}
                </button>
              )}
              <div className="mt-2">
                {intl.formatMessage(messages.timeRemaining)}:{' '}
                <strong>{`${hrs.toString().length > 1 ? hrs : `0${hrs}`}:${
                  mins.toString().length > 1 ? mins : `0${mins}`
                }:${secs.toString().length > 1 ? secs : `0${secs}`}`}</strong>
              </div>
            </Col>
          </Row>
        </div>
      )}
      <Modal
        show={modalFinished}
        title={intl.formatMessage(messages.finishAttempt)}
        message={finishMessage(essayLengthError, intl, essayDetails)}
        onClose={() => setModalFinished(false)}
        icon="pe-7s-check"
        buttons={[
          {
            onClick: () => setModalFinished(false),
            label: intl.formatMessage(messages.cancel),
          },
          {
            onClick: () => handleFinishAttempt(),
            label: intl.formatMessage(messages.continue),
          },
        ]}
      />

      <Modal
        show={showModalComposing && showOneTime}
        title={intl.formatMessage(messages.startComposing)}
        onClose={() => setShowModalComposing(false)}
        icon="pe-7s-bookmarks"
        buttons={[
          {
            onClick: () => setShowModalComposing(false),
            label: intl.formatMessage(messages.cancel),
          },
          {
            onClick: () => handleShowModalComposing(),
            label: intl.formatMessage(messages.start),
          },
        ]}
      >
        <div
          className="mt-2"
          dangerouslySetInnerHTML={{
            __html: intl.formatHTMLMessage(messages.composingInstructionText, {
              minChar: essayDetails ? essayDetails.minChars : 1400,
              maxChar: essayDetails ? essayDetails.maxChars : 2850,
            }),
          }}
        ></div>
      </Modal>
    </div>
  );
};

const finishMessage = (essayLengthError, intl, essayDetails) => (
  <div
    dangerouslySetInnerHTML={{
      __html:
        essayLengthError === 'max'
          ? intl.formatHTMLMessage(messages.finishAttemptMaxEssayMessage)
          : essayLengthError === 'min'
          ? intl.formatHTMLMessage(messages.finishAttemptMinEssayMessage, {
              minChar: essayDetails ? essayDetails.minChars : 1400,
            })
          : intl.formatHTMLMessage(messages.finishAttemptMessage),
    }}
  />
);

const mapStateToProps = ({ onlineSimulated, app }) => ({ ...onlineSimulated, ...app });

export default compose(
  connect(mapStateToProps, {
    answerEvaluationOnline,
    answerQuestion,
    finishScheduledAssessment,
    viewEvaluationOnline,
    getEvaluationEssayDetails,
    saveEvaluationEssayText,
  }),
  injectIntl,
)(SimulatedEvaluationContainer);
